// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  justify-content: space-between;
  padding: 12px 12px 0 12px;
}

.key {
  width: 6%;
}

.key1 {
  width: 9.42%;
}

.key2 {
  width: 11.13%;
}

.key3 {
  width: 14.55%;
}

.key4 {
  width: 7.71%;
}

.key_null {
  width: 18%;
}

.key_space {
  width: 41%;
}

.vk-invisible {
  display: none;
}
.vk-invisible > .row {
  pointer-events: none;
}

.vk-visible {
  display: block;
}
.vk-visible > .row {
  pointer-events: none;
}

.vk-clickable > .row {
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/virtual-keyboard/virtual-keyboard.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,yBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,aAAA;AACJ;AACI;EACI,oBAAA;AACR;;AAGA;EACI,cAAA;AAAJ;AAEI;EACI,oBAAA;AAAR;;AAKI;EACI,mBAAA;AAFR","sourcesContent":[".row {\n    display: flex;\n    justify-content: space-between;\n    padding: 12px 12px 0 12px;\n}\n\n.key {\n    width: 6%;\n}\n\n.key1 {\n    width: 9.42%;\n}\n\n.key2 {\n    width: 11.13%;\n}\n\n.key3 {\n    width: 14.55%;\n}\n\n.key4 {\n    width: 7.71%;\n}\n\n.key_null {\n    width: 18%;\n}\n\n.key_space {\n    width: 41%;\n}\n\n.vk-invisible {\n    display: none;\n\n    & > .row {\n        pointer-events: none;\n    }\n}\n\n.vk-visible {\n    display: block;\n\n    & > .row {\n        pointer-events: none;\n    }\n}\n\n.vk-clickable {\n    & > .row {\n        pointer-events: all;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
